import React, { useState } from 'react';
import { Button, Modal, Tooltip } from 'antd';
import { MobileOutlined, ScanOutlined, FireOutlined } from '@ant-design/icons';
import ScanSession from './ScanSession';

const ScanButton = ({ folderPath, folderNumber, moduleType, folderName, username, onProcessComplete, isFuelMode = false }) => {
  const [scanModalOpen, setScanModalOpen] = useState(false);

  const handleClose = () => {
    setScanModalOpen(false);
  };

  const handleProcessComplete = (results) => {
    if (onProcessComplete) onProcessComplete(results);
  };

  return (
    <>
      <Tooltip title={isFuelMode ? "Scan fuel invoices with phone camera" : "Scan invoices with your phone camera"}>
        <Button
          icon={isFuelMode ? <FireOutlined /> : <MobileOutlined />}
          onClick={() => setScanModalOpen(true)}
          style={{
            borderRadius: 8,
            fontWeight: 600,
            background: isFuelMode
              ? 'linear-gradient(135deg, #d46b08, #fa8c16)'
              : 'linear-gradient(135deg, #722ed1, #9254de)',
            color: '#fff',
            border: 'none',
            boxShadow: isFuelMode
              ? '0 2px 8px rgba(250,140,22,0.25)'
              : '0 2px 8px rgba(114,46,209,0.25)',
          }}
        >
          <ScanOutlined style={{ marginRight: 4 }} />
          {isFuelMode ? '⛽ Fuel Scanner' : 'Phone Scanner'}
        </Button>
      </Tooltip>

      <Modal
        title={null}
        open={scanModalOpen}
        onCancel={handleClose}
        footer={null}
        width={1100}
        style={{ top: 20 }}
        styles={{ body: { padding: '20px', maxHeight: '85vh', overflowY: 'auto' } }}
        destroyOnClose
      >
        <ScanSession
          folderPath={folderPath}
          folderNumber={folderNumber}
          moduleType={moduleType}
          folderName={folderName}
          username={username}
          onClose={handleClose}
          onProcessComplete={handleProcessComplete}
          isFuelMode={isFuelMode}
        />
      </Modal>
    </>
  );
};

export default ScanButton;